import { render } from "./RelatorioAcessos.vue?vue&type=template&id=7486ea56&scoped=true"
import script from "./RelatorioAcessos.vue?vue&type=script&lang=js"
export * from "./RelatorioAcessos.vue?vue&type=script&lang=js"

import "./RelatorioAcessos.vue?vue&type=style&index=0&id=7486ea56&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7486ea56"]])

export default __exports__